<template>
<div class="footer-container">
  <div class="uk-container uk-container-small uk-padding footer">
{{ $t("footer.title")}}<br/>
<router-link :to="`/${$i18n.locale}/impressum`">{{ $t("footer.impressum")}}</router-link>
<LocaleChanger></LocaleChanger>
</div>
</div>
</template>

<script>
import LocaleChanger from "@/components/LocaleChanger"
export default {
  name: 'App',
components: {
  LocaleChanger
}
}
</script>